/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from "react";
import {
  FaUser,
  FaPhone,
  FaEnvelope,
  FaCity,
  FaCalendarAlt,
  FaClock,
  FaUsers,
  FaBuilding,
  FaUtensils,
  FaSnowflake,
  FaMoneyBillWave,
  FaFileSignature,
  FaMicrophone,
  FaCamera,
  FaCar,
} from "react-icons/fa";

// const BASE_PRICE = 800;
// const CATERING_PRICE = 300;
// const DECORATION_PRICE = 15000;
// const PRICE_PER_GUEST = 800;

const BookingForm = ({ onSubmit, availabilityData, editData }) => {
  const isEditMode = Boolean(editData?.Id);
  const [activeDept, setActiveDept] = useState(null);
  const [formData, setFormData] = useState({
    fullName: "",
    mobile: "",
    email: "",
    altMobile: "",
    city: "",

    eventTypeId: "",
    hallId: availabilityData?.hallId || "",

    packageId: "",
    packagePrice: "", // NEW (manual override)

    eventDate: availabilityData?.eventDate || "",
    startTime: "",
    endTime: "",
    guests: "",
    // guestPrice: PRICE_PER_GUEST.toString(),   // NEW (per guest price)

    foodType: "",
    acPreference: "",

    paymentMethod: "",
    services: [],

    customRequirements: "",
    panGst: "",
    companyName: "",
    billingAddress: "",
    eventPlanner: "",

    termsAccepted: false,
  });
  const [menuList, setMenuList] = useState([]);
  const [selectedMenu, setSelectedMenu] = useState([]);
  const [selectedPackage, setSelectedPackage] = useState(null);
  const [total, setTotal] = useState(0);
  const [advance, setAdvance] = useState(0);
  const [errors, setErrors] = useState({});
  const [halls, setHalls] = useState([]);
  const [eventTypes, setEventTypes] = useState([]);
  const [packages, setPackages] = useState([]);
  const [servicesList, setServicesList] = useState([]);
  const [showMenuDrawer, setShowMenuDrawer] = useState(false);
  const [search, setSearch] = useState("");

  const [openDepts, setOpenDepts] = useState([]);
  const API_URL = process.env.REACT_APP_API_URL;
  useEffect(() => {
    if (!search) return;

    setOpenDepts(Object.keys(filteredMenu));
  }, [search]);

  const toggleDept = (dept) => {
    setOpenDepts((prev) =>
      prev.includes(dept) ? prev.filter((d) => d !== dept) : [...prev, dept],
    );
  };
  const filteredMenu = Object.keys(menuList).reduce((acc, dept) => {
    const items = menuList[dept].filter((item) =>
      item.I_Name.toLowerCase().includes(search.toLowerCase()),
    );

    if (items.length > 0) {
      acc[dept] = items;
    }

    return acc;
  }, {});

  useEffect(() => {
    const fetchMasters = async () => {
      const [h, e, p, s] = await Promise.all([
        fetch(`${API_URL}/api/halls`),
        fetch(`${API_URL}/api/event-types`),
        fetch(`${API_URL}/api/packages`),
        fetch(`${API_URL}/api/services`),
      ]);

      setHalls(await h.json());
      setEventTypes(await e.json());
      setPackages(await p.json());
      setServicesList(await s.json());
    };

    fetchMasters();
  }, []);

  useEffect(() => {
    fetch(`${API_URL}/api/menu`)
      .then((res) => res.json())
      .then((data) => setMenuList(data))
      .catch((err) => console.error("Menu fetch error:", err));
  }, []);

  useEffect(() => {
    if (editData) {
      const d = editData;

      // HANDLE BOTH FORMATS
      const normalized = {
        fullName: d.fullName || d.FullName || "",
        mobile: d.mobile || d.Mobile || "",
        email: d.email || d.Email || "",
        altMobile: d.altMobile || d.AltMobile || "",
        city: d.city || d.City || "",

        eventTypeId: d.eventTypeId || d.EventTypeId || "",
        hallId: d.hallId || d.HallId || "",
        packageId: d.packageId || d.PackageId || "",

        eventDate: d.eventDate
          ? d.eventDate.split("T")[0]
          : d.EventDate
            ? d.EventDate.split("T")[0]
            : "",

        startTime: d.startTime || d.StartTime || "",
        endTime: d.endTime || d.EndTime || "",

        guests: d.guests || d.Guests || "",

        acPreference: d.acPreference || d.ACPreference || "",
        foodType: d.foodType || d.FoodType || "",
        paymentMethod: d.paymentMethod || d.PaymentMethod || "",

        services: d.services || [],

        customRequirements: d.customRequirements || d.CustomRequirements || "",

        panGst: d.panGst || d.PanGst || "",
        companyName: d.companyName || d.CompanyName || "",
        billingAddress: d.billingAddress || d.BillingAddress || "",
        eventPlanner: d.eventPlanner || d.EventPlanner || "",

        termsAccepted: true,
      };

      setFormData(normalized);
      if (d.menu && Array.isArray(d.menu)) {
        setSelectedMenu(d.menu);
      }
    }
  }, [editData]);

  // useEffect(() => {
  //   let price = 0;
  //   if (formData.guests) price += formData.guests * BASE_PRICE;
  //   if (formData.catering) price += formData.guests * CATERING_PRICE;
  //   if (formData.decoration) price += DECORATION_PRICE;

  //   setTotal(price);
  //   setAdvance(Math.floor(price * 0.3));
  // }, [formData]);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({
      ...formData,
      [name]: type === "checkbox" ? checked : value,
    });
  };

  const validateForm = () => {
    const newErrors = {};

    if (!formData.fullName.trim()) newErrors.fullName = "Full name is required";

    if (!formData.mobile.trim()) newErrors.mobile = "Mobile number is required";
    else if (!/^[0-9]{10}$/.test(formData.mobile))
      newErrors.mobile = "Enter valid 10 digit mobile number";

    if (!formData.eventTypeId) newErrors.eventTypeId = "Event type is required";

    if (!formData.eventDate) newErrors.eventDate = "Event date is required";

    if (!formData.startTime) newErrors.startTime = "Start time is required";

    if (!formData.endTime) newErrors.endTime = "End time is required";

    if (!formData.guests) newErrors.guests = "Guest count required";
    else if (formData.guests <= 0)
      newErrors.guests = "Guests must be greater than 0";

    if (!formData.hallId) newErrors.hallId = "Hall selection required";

    if (!formData.foodType) newErrors.foodType = "Food Type required";

    if (!formData.paymentMethod)
      newErrors.paymentMethod = "Payment method required";

    if (!formData.packageId) newErrors.packageId = "Package type required";

    if (!formData.termsAccepted)
      newErrors.termsAccepted = "Accept Terms & Conditions";

    setErrors(newErrors);

    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!validateForm()) return;

    onSubmit({
      ...formData,
      Id: editData?.Id || null,
      total,
      advance,
      menu: selectedMenu || [],
    });
  };

  const toggleService = (service) => {
    const exists = formData.services.find((s) => s.id === service.Id);

    if (exists) {
      setFormData({
        ...formData,
        services: formData.services.filter((s) => s.id !== service.Id),
      });
    } else {
      setFormData({
        ...formData,
        services: [
          ...formData.services,
          { id: service.Id, price: service.DefaultPrice },
        ],
      });
    }
  };

  useEffect(() => {
    const total = formData.services.reduce(
      (sum, s) => sum + Number(s.price || 0),
      0,
    );

    setTotal(total);
    setAdvance(Math.floor(total * 0.3));
  }, [formData.services]);

  useEffect(() => {
    if (!formData.packageId || packages.length === 0) return;

    const selected = packages.find(
      (p) => String(p.Id) === String(formData.packageId),
    );

    setSelectedPackage(selected);
    if (!selected) return;

    setFormData((prev) => ({
      ...prev,
      packagePrice: selected.Price || 0,
    }));

    if (selected.PackageType === "STANDARD") {
      if (!isEditMode) {
        fetch(`${API_URL}/api/package-menu/${selected.Id}`)
          .then((res) => res.json())
          .then((data) => {
            setSelectedMenu(data);
          });
      }

      setShowMenuDrawer(false);
    } else {
      // CUSTOM package
      setSelectedMenu([]);

      // AUTO OPEN DRAWER HERE
      setShowMenuDrawer(true);
    }
  }, [formData.packageId, packages]);

  const toggleMenu = (item) => {
    const exists = selectedMenu.find((m) => m.ID === item.ID);

    if (exists) {
      setSelectedMenu(selectedMenu.filter((m) => m.ID !== item.ID));
    } else {
      setSelectedMenu([...selectedMenu, item]);
    }
  };
  useEffect(() => {
    const guests = Number(formData.guests) || 0;
    const packagePrice = Number(formData.packagePrice) || 0;

    const servicesTotal = formData.services.reduce(
      (sum, s) => sum + Number(s.price || 0),
      0,
    );

    const packageTotal = guests * packagePrice;

    const total = packageTotal + servicesTotal;

    setTotal(total);
    setAdvance(Math.floor(total * 0.3));
  }, [formData.guests, formData.packagePrice, formData.services]);

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-100 via-white to-emerald-100 flex justify-center items-center">
      <div className="bg-white shadow-2xl rounded-3xl w-full max-w-5xl p-10 border border-gray-200 transition-all duration-500 hover:shadow-blue-200">
        <h2 className="text-3xl font-bold text-center mb-8 bg-gradient-to-r from-blue-600 to-emerald-500 bg-clip-text text-transparent tracking-wide">
          {isEditMode ? "Edit Booking Form" : "Banquet Booking Form"}
        </h2>

        <form onSubmit={handleSubmit} className="space-y-2">
          <Section title="Customer Information" icon={<FaUser />} />
          <Grid>
            <Input
              name="fullName"
              label="Full Name"
              required
              placeholder="Enter full name"
              icon={<FaUser />}
              value={formData.fullName}
              onChange={handleChange}
              error={errors.fullName}
            />
            <Input
              name="mobile"
              label="Mobile Number"
              required
              placeholder="Enter mobile number"
              icon={<FaPhone />}
              value={formData.mobile}
              onChange={handleChange}
              error={errors.mobile}
            />
            <Input
              name="email"
              label="Email Address"
              placeholder="Enter email address"
              icon={<FaEnvelope />}
              value={formData.email}
              onChange={handleChange}
            />
            <Input
              name="altMobile"
              label="Alternate Contact"
              placeholder="Enter alternate number"
              icon={<FaPhone />}
              value={formData.altMobile}
              onChange={handleChange}
            />
            <Input
              name="city"
              label="City"
              placeholder="Enter your city"
              required
              icon={<FaCity />}
              value={formData.city}
              onChange={handleChange}
              error={errors.city}
            />
          </Grid>

          <Section title="Event Details" icon={<FaCalendarAlt />} />
          <Grid>
            <Select
              name="eventTypeId"
              label="Event Type"
              value={formData.eventTypeId}
              required
              icon={<FaCalendarAlt />}
              onChange={handleChange}
              error={errors.eventType}
              options={eventTypes.map((e) => ({
                label: e.EventName,
                value: e.Id,
              }))}
            />
            <Input
              type="date"
              name="eventDate"
              label="Event Date"
              required
              icon={<FaCalendarAlt />}
              value={formData.eventDate}
              onChange={handleChange}
              readOnly
              error={errors.eventDate}
            />
            <Input
              type="time"
              name="startTime"
              label="Start Time"
              icon={<FaClock />}
              value={formData.startTime}
              onChange={handleChange}
              error={errors.startTime}
              required
            />
            <Input
              type="time"
              name="endTime"
              label="End Time"
              icon={<FaClock />}
              value={formData.endTime}
              onChange={handleChange}
              error={errors.endTime}
              required
            />
            <Input
              type="number"
              name="guests"
              label="Number of Guests"
              required
              placeholder="Enter total guests"
              icon={<FaUsers />}
              value={formData.guests}
              onChange={handleChange}
              error={errors.guests}
            >
              {/* <input
    type="number"
    name="guestPrice"
    value={formData.guestPrice || ""}
    onChange={handleChange}
    className="border rounded px-2 py-1 w-32"
    placeholder="Price"
  /> */}
            </Input>
            <Select
              name="hallId"
              label="Hall"
              value={formData.hallId}
              onChange={handleChange}
              options={halls.map((h) => ({
                label: h.Name,
                value: h.Id,
              }))}
              error={errors.hall}
              required
              icon={<FaBuilding />}
            />
          </Grid>

          <Section title="Service Requirements" icon={<FaUtensils />} />
          <Grid>
            <Select
              name="acPreference"
              label="AC Preference"
              icon={<FaSnowflake />}
              options={["AC", "Non-AC"]}
              value={formData.acPreference}
              onChange={handleChange}
            />
            <Select
              name="foodType"
              label="Food Type"
              icon={<FaUtensils />}
              options={["Veg", "Non-Veg", "Both"]}
              value={formData.foodType}
              onChange={handleChange}
              error={errors.foodType}
              required
            />
            {servicesList.map((service) => (
              <div
                key={service.Id}
                className="flex justify-between items-center border p-2 rounded"
              >
                <label>
                  <input
                    type="checkbox"
                    className="cursor-pointer"
                    checked={formData.services.some((s) => s.id === service.Id)}
                    onChange={() => toggleService(service)}
                  />
                  {service.ServiceName}
                </label>

                <input
                  type="number"
                  value={
                    formData.services.find((s) => s.id === service.Id)?.price ||
                    ""
                  }
                  onChange={(e) => {
                    const exists = formData.services.find(
                      (s) => s.id === service.Id,
                    );

                    if (!exists) return;

                    const updated = formData.services.map((s) =>
                      s.id === service.Id ? { ...s, price: e.target.value } : s,
                    );

                    setFormData({ ...formData, services: updated });
                  }}
                  className="w-24 border rounded px-2"
                />
              </div>
            ))}
          </Grid>

          <Section title="Pricing & Payment" icon={<FaMoneyBillWave />} />
          <Grid>
            <Select
              name="packageId"
              label="Package"
              value={formData.packageId}
              onChange={handleChange}
              options={packages.map((p) => ({
                label: p.PackageName,
                value: p.Id,
              }))}
              icon={<FaMoneyBillWave />}
              error={errors.packageType}
              required
            />

            {formData.packageId && (
              <Input
                type="number"
                name="packagePrice"
                label="Package Price (Per Person)"
                value={formData.packagePrice}
                onChange={handleChange}
                icon={<FaMoneyBillWave />}
              />
            )}
            <Select
              name="paymentMethod"
              label="Payment Method"
              icon={<FaMoneyBillWave />}
              options={["UPI", "Card", "Net Banking", "Pay Later"]}
              value={formData.paymentMethod}
              onChange={handleChange}
              error={errors.paymentMethod}
              required
            />
          </Grid>

          {formData.packageId && (
            <>
              <Section title="Menu Selection" icon={<FaUtensils />} />

              <div className="space-y-3">
                {/* Show button only for CUSTOM */}
                {selectedPackage?.PackageType === "CUSTOM" && (
                  <button
                    type="button"
                    onClick={() => setShowMenuDrawer(true)}
                    className="w-full flex justify-between items-center bg-gradient-to-r from-blue-600 to-indigo-600 text-white px-4 py-3 rounded-xl shadow hover:scale-[1.01] transition"
                  >
                    <span>Select Menu Items</span>
                    <span className="text-sm opacity-80">
                      {selectedMenu.length} selected
                    </span>
                  </button>
                )}

                {/* SAME UI for both */}
                <div className="border rounded-2xl bg-white p-4 shadow-sm">
                  {/* Header */}
                  <div className="flex justify-between items-center mb-3">
                    <h4 className="font-semibold text-gray-700">
                      Menu Items ({selectedMenu.length})
                    </h4>

                    {/* Clear only for CUSTOM */}
                    {selectedPackage?.PackageType === "CUSTOM" &&
                      selectedMenu.length > 0 && (
                        <button
                          onClick={() => setSelectedMenu([])}
                          className="text-sm text-red-500 hover:underline"
                        >
                          Clear All
                        </button>
                      )}
                  </div>

                  {/* Empty State */}
                  {selectedMenu.length === 0 ? (
                    <p className="text-gray-500 text-sm">No menu assigned</p>
                  ) : (
                    <div className="flex flex-wrap gap-2 max-h-32 overflow-y-auto">
                      {selectedMenu.map((item) => (
                        <div
                          key={item.ID}
                          className="flex items-center gap-2 bg-blue-50 text-blue-700 border border-blue-100 px-3 py-1 rounded-full text-sm transition hover:shadow-sm"
                        >
                          <span>{item.I_Name}</span>

                          {/* Remove only for CUSTOM */}
                          {selectedPackage?.PackageType === "CUSTOM" && (
                            <button
                              onClick={() =>
                                setSelectedMenu((prev) =>
                                  prev.filter((i) => i.ID !== item.ID),
                                )
                              }
                              className="text-gray-400 hover:text-red-500"
                            >
                              ✕
                            </button>
                          )}
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              </div>
            </>
          )}

          <div className="bg-gray border border-gray-200 text-gray-800 p-5 rounded-2xl shadow-sm transition-all duration-300 hover:shadow-md">
            {/* Title */}
            <h3 className="text-lg font-bold mb-3 opacity-90">
              Pricing Summary
            </h3>

            {/* Breakdown */}
            <div className="space-y-1 text-sm opacity-90">
              <p>
                Package: {formData.guests || 0} × ₹{formData.packagePrice || 0}
              </p>
              <p>
                Services: ₹
                {formData.services.reduce(
                  (s, x) => s + Number(x.price || 0),
                  0,
                )}
              </p>
            </div>

            {/* Divider */}
            <div className="border-t border-white/30 my-3"></div>

            {/* Total */}
            <div className="flex justify-between items-center">
              <span className="text-lg font-bold">Total</span>
              <span className="text-2xl font-bold">₹{total}</span>
            </div>

            {/* Advance */}
            <div className="flex justify-between items-center mt-1 text-sm opacity-90">
              <span>Advance (30%)</span>
              <span className="text-lg font-semibold">₹{advance}</span>
            </div>
          </div>
          {/* ================= Additional Notes ================= */}

          <Section title="Additional Notes" icon={<FaFileSignature />} />
          <Grid2>
            {/* <Textarea
              name="specialInstructions"
              label="Special Instructions"
              placeholder="Any special instructions for the event"
              onChange={handleChange}
              value={formData.specialInstructions}
            />
            <Textarea
              name="themePreference"
              label="Theme Preference"
              placeholder="Preferred theme or decoration style"
              onChange={handleChange}
              value={formData.themePreference}
            /> */}
            <Textarea
              name="customRequirements"
              label="Custom Requirements"
              placeholder="Any custom requirements"
              onChange={handleChange}
              value={formData.customRequirements}
            />
          </Grid2>

          {/* ================= Corporate Details ================= */}

          {formData.eventType === "Corporate" && (
            <>
              <Section title="Corporate Details" icon={<FaBuilding />} />
              <Grid>
                <Input
                  name="panGst"
                  label="PAN / GST Number"
                  placeholder="Enter PAN or GST number"
                  icon={<FaFileSignature />}
                  onChange={handleChange}
                  value={formData.panGst}
                />
                <Input
                  name="companyName"
                  label="Company Name"
                  placeholder="Enter company name"
                  icon={<FaBuilding />}
                  value={formData.companyName}
                  onChange={handleChange}
                />
                <Input
                  name="billingAddress"
                  label="Billing Address"
                  placeholder="Enter billing address"
                  icon={<FaBuilding />}
                  value={formData.billingAddress}
                  onChange={handleChange}
                />
                <Input
                  name="eventPlanner"
                  label="Event Planner Name"
                  placeholder="Enter planner name"
                  icon={<FaUser />}
                  value={formData.eventPlanner}
                  onChange={handleChange}
                />
              </Grid>
            </>
          )}
          <Section title="Agreement" icon={<FaFileSignature />} />
          {/* <Checkbox
            name="cancellationPolicy"
            label="I agree to Cancellation Policy"
            onChange={handleChange}
            value={formData.cancellationPolicy}
          /> */}
          <Checkbox
            name="termsAccepted"
            label="I accept Terms & Conditions"
            required
            onChange={handleChange}
            checked={formData.termsAccepted}
            error={errors.termsAccepted}
          />
          {/* <Checkbox
            name="refundPolicy"
            label="I acknowledge Refund Policy"
            onChange={handleChange}
            value={formData.refundPolicy}
          /> */}

          <div className="flex justify-start pt-5">
            <button className="mt-1 bg-gradient-to-r from-blue-600 to-emerald-500 hover:from-blue-700 hover:to-emerald-600 text-white py-3 px-6  transform hover:scale-105 transition-all duration-300 shadow-lg font-semibold tracking-wide">
              {isEditMode ? "Confirm Edit" : "Confirm Booking"}
            </button>
          </div>

          {showMenuDrawer && (
            <>
              {/* BACKDROP */}
              <div
                className="fixed inset-0 bg-black/30 z-40"
                onClick={() => setShowMenuDrawer(false)}
              />

              {/* DRAWER */}
              <div className="fixed top-0 right-0 h-full w-[420px] bg-white z-50 shadow-2xl flex flex-col">
                {/* HEADER */}
                <div className="p-4 border-b flex justify-between items-center">
                  <h3 className="font-bold text-2xl text-center">
                    Select Menu
                  </h3>
                  <button onClick={() => setShowMenuDrawer(false)}>✕</button>
                </div>

                {/* SEARCH */}
                <div className="p-3 border-b">
                  <input
                    type="text"
                    placeholder="Search..."
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                    className="w-full border px-3 py-2 rounded"
                  />
                </div>

                {/* MENU LIST */}
                <div className="flex-1 overflow-y-auto p-3 space-y-2">
                  {Object.keys(filteredMenu).map((dept) => {
                    const isOpen = openDepts.includes(dept);

                    return (
                      <div key={dept} className="border rounded">
                        <div
                          onClick={() => toggleDept(dept)}
                          className="flex justify-between p-2 cursor-pointer"
                        >
                          <span className="font-semibold">{dept}</span>
                          <span>
                            {" "}
                            <img
                              src={isOpen ? "/up.svg" : "/down.svg"}
                              alt="toggle"
                              width={16}
                              height={16}
                            />
                          </span>
                        </div>

                        {isOpen && (
                          <div className="p-2 border-t space-y-1">
                            {filteredMenu[dept].map((item) => {
                              const isSelected = selectedMenu.some(
                                (m) => m.ID === item.ID,
                              );

                              return (
                                <div
                                  key={item.ID}
                                  onClick={() => toggleMenu(item)}
                                  className={`flex items-center justify-between p-3 rounded-lg cursor-pointer transition border ${
                                    isSelected
                                      ? "bg-blue-50 border-blue-400"
                                      : "border-transparent hover:bg-gray-100"
                                  }`}
                                >
                                  <div className="flex items-center gap-3">
                                    {/* CUSTOM CHECKBOX */}
                                    <div
                                      className={`w-5 h-5 flex items-center justify-center rounded border-2 transition ${
                                        isSelected
                                          ? "bg-blue-600 border-blue-600"
                                          : "border-gray-400"
                                      }`}
                                    >
                                      {isSelected && (
                                        <span className="text-white text-xs">
                                          ✓
                                        </span>
                                      )}
                                    </div>

                                    <span className="text-gray-800 font-medium">
                                      {item.I_Name}
                                    </span>
                                  </div>
                                </div>
                              );
                            })}
                          </div>
                        )}
                      </div>
                    );
                  })}
                </div>

                {/* FOOTER */}
                <div className="p-4 border-t flex justify-between">
                  <span>{selectedMenu.length} selected</span>

                  <button
                    onClick={() => setShowMenuDrawer(false)}
                    className="bg-blue-600 text-white px-4 py-2 rounded"
                  >
                    Done
                  </button>
                </div>
              </div>
            </>
          )}
        </form>
      </div>
    </div>
  );
};

export default BookingForm;

/* ================= Reusable Components ================= */

const Section = ({ title, icon }) => (
  <div className="flex items-center gap-3 mt-3">
    <div className="text-blue-900 text-xl mt-6">{icon}</div>
    <h3 className="text-xl font-semibold border-b flex-1 pb-2 mt-8">{title}</h3>
  </div>
);

const Grid = ({ children }) => (
  <div className="grid md:grid-cols-2 gap-6">{children}</div>
);
const Grid2 = ({ children }) => (
  <div className="grid md:grid-cols-1 gap-6">{children}</div>
);

const Input = ({
  type = "text",
  name,
  label,
  required,
  onChange,
  placeholder,
  icon,
  value,
  readOnly,
  error,
  children, // add this
}) => (
  <div className="flex flex-col group">
    <label className="text-sm font-semibold mb-1 text-blue-700">
      {label} {required && <span className="text-red-500">*</span>}
    </label>

    <div className="relative flex items-center gap-2">
      {icon && (
        <span className="absolute left-3 top-1/2 -translate-y-1/2 text-blue-400">
          {icon}
        </span>
      )}

      <input
        type={type}
        name={name}
        value={value || ""}
        onChange={onChange}
        placeholder={placeholder}
        readOnly={readOnly}
        className={`w-full pl-10 pr-4 py-2 rounded-lg border transition-all
    ${error ? "border-red-500" : "border-gray-300"}
    ${
      readOnly
        ? "bg-gray-100 text-gray-500 cursor-not-allowed pointer-events-none"
        : "focus:ring-2 focus:ring-emerald-500"
    }
  `}
      />

      {/*  render extra input */}
      {children}
    </div>

    {error && <span className="text-red-500 text-xs mt-1">{error}</span>}
  </div>
);

const Select = ({
  name,
  label,
  options,
  required,
  onChange,
  icon,
  value,
  error,
}) => (
  <div className="flex flex-col group">
    <label className="text-sm font-semibold mb-1 text-blue-700">
      {label} {required && <span className="text-red-500">*</span>}
    </label>

    <div className="relative">
      {icon && (
        <span className="absolute left-3 top-1/2 -translate-y-1/2 text-blue-400">
          {icon}
        </span>
      )}

      <select
        name={name}
        value={value || ""}
        onChange={onChange}
        className={`w-full pl-10 pr-4 py-2 rounded-xl border ${
          error ? "border-red-500" : "border-gray-300"
        } focus:ring-2 focus:ring-emerald-500`}
      >
        <option value="">Select {label}</option>
        {options.map((opt, i) => (
          <option key={opt.value || opt} value={opt.value || opt}>
            {opt.label || opt}
          </option>
        ))}
      </select>
    </div>

    {error && <span className="text-red-500 text-xs mt-1">{error}</span>}
  </div>
);

const Textarea = ({ name, label, required, onChange, placeholder }) => (
  <div className="flex flex-col group">
    <label className="text-sm font-semibold mb-1 text-blue-700 group-focus-within:text-emerald-600 transition-all">
      {label} {required && <span className="text-red-500">*</span>}
    </label>
    <textarea
      name={name}
      onChange={onChange}
      placeholder={placeholder}
      rows={3}
      className="w-full px-4 py-2 rounded-xl border border-gray-300 focus:ring-2 focus:ring-emerald-500 focus:border-emerald-500 transition-all shadow-sm"
    />
  </div>
);

const Checkbox = ({
  name,
  label,
  required,
  onChange,
  icon,
  checked,
  error,
}) => (
  <div className="flex flex-col">
    <div className="flex items-center gap-3 bg-gray-50 p-3 rounded-xl shadow-sm hover:bg-emerald-50 transition-all duration-300 hover:shadow-md cursor-pointer">
      <input
        type="checkbox"
        name={name}
        checked={checked}
        onChange={onChange}
        className="w-5 h-5 accent-emerald-600"
      />
      {icon && <span className="text-blue-500">{icon}</span>}
      <label className="text-gray-700">
        {label} {required && <span className="text-red-500">*</span>}
      </label>
    </div>

    {error && <span className="text-red-500 text-xs mt-1">{error}</span>}
  </div>
);
